export enum ErrorCode {
  PATCH_NOTE_NOT_FOUND,
  PATCH_NOTE_RELEASE_DATE_CONFLICT,
  VERSION_NOT_FOUND,
}
